import Cookies from "js-cookie";
import FontFaceObserver from "fontfaceobserver";

// Don't display the background site contents until the age is verified
function renderPage() {
  const fonts = Promise.all([
    new FontFaceObserver("Avenir Next", {
      weight: 400,
      style: "normal",
    }).load(),
    new FontFaceObserver("Avenir Next", {
      weight: 500,
      style: "normal",
    }).load(),
    new FontFaceObserver("Avenir Next", {
      weight: 600,
      style: "normal",
    }).load(),
    new FontFaceObserver("Avenir Next", {
      weight: 700,
      style: "normal",
    }).load(),
    new FontFaceObserver("Avenir Next", {
      weight: 900,
      style: "normal",
    }).load(),
    new FontFaceObserver("Bigola Display", {
      weight: 400,
      style: "normal",
    }).load(),
    new FontFaceObserver("White Oleander Upright", {
      weight: 400,
      style: "normal",
    }).load(),
  ]).then(() => {
    // Check if the cookie exists
    const age_verified = !!Cookies.get("age_verified");
    if (age_verified) {
      gsap.to("#smooth-content", {
        opacity: 1,
        duration: 0.35,
      });
    }
  });
}

renderPage();
